export default __webpack_public_path__ + "static/media/promocionAlarma2Mobile.cb7258ce.png";